import { PAGE_SIZE } from "components";
import { typedQueryClient, useTypedQuery } from "hooks";
import { RecallsDashboardKeys } from "modules/RecallsDashboard/queryKeys";
import { RECALLS_DASHBOARD_KEYS } from "modules/RecallsDashboard/storageKeys";
import { RecallsDashboardFilters } from "modules/RecallsDashboard/types";
import { getPreference } from "util/common";

const defaultFilters: RecallsDashboardFilters = {
  page: 1,
  page_size: getPreference(RECALLS_DASHBOARD_KEYS.PageSizePreference, PAGE_SIZE.PageSize25),
  term: "",
  status: null
};

export const useRecallsDashboardFilters = () => useTypedQuery({ queryKey: RecallsDashboardKeys.filters, initialData: defaultFilters });

export const useUpdateRecallsDashboardFilters = () => {
  const { data: oldFilters } = useRecallsDashboardFilters();

  return (newFilters: Partial<RecallsDashboardFilters>) => typedQueryClient.setQueryData(RecallsDashboardKeys.filters, { ...oldFilters, ...newFilters });
};
